import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  Grid, 
  Link,
} from '@mui/material';
import { 
  MailOutline, 
  PhoneAndroid, 
  LocationOn, 
  Business 
} from '@mui/icons-material';

const ContactUsPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f8fafc' }}>
      
      <Container maxWidth="md" sx={{ py: 8, flexGrow: 1 }}>
        <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          {/* Header Section */}
          <Box sx={{ color: 'white', py: 6, px: 4, textAlign: 'center' }}>
            <Typography variant="h3" component="h1" fontWeight="700" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
              We are here to help you with any queries
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 4, md: 8 } }}>
            <Grid container spacing={6}>
              {/* Merchant Details */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" color="text.primary" fontWeight="600" gutterBottom sx={{ mb: 3 }}>
                  Merchant Details
                </Typography>
                
                <Box sx={{ display: 'flex', mb: 4 }}>
                  <Business sx={{ color: '#1976d2', mr: 2, mt: 0.5 }} />
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
                      Legal Entity Name
                    </Typography>
                    <Typography variant="body1" fontWeight="600">Lawfullingo</Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex' }}>
                  <LocationOn sx={{ color: '#1976d2', mr: 2, mt: 0.5 }} />
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
                      Registered Address
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      Hisar<br />
                      HARYANA 125001
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Contact Info */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" color="text.primary" fontWeight="600" gutterBottom sx={{ mb: 3, display: { xs: 'none', md: 'block' } }}>
                  &nbsp;
                </Typography>

                <Box sx={{ display: 'flex', mb: 4 }}>
                  <PhoneAndroid sx={{ color: '#1976d2', mr: 2, mt: 0.5 }} />
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
                      Telephone No
                    </Typography>
                    <Typography variant="body1">
                      
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', mb: 4 }}>
                  <MailOutline sx={{ color: '#1976d2', mr: 2, mt: 0.5 }} />
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
                      E-Mail ID
                    </Typography>
                    <Typography variant="body1">
                      <Link href="mailto:lawfullingo2017@gmail.com" sx={{ color: '#1976d2', textDecoration: 'none', fontWeight: 600 }}>
                        lawfullingo2017@gmail.com
                      </Link>
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mt: 2, p: 2, bgcolor: '#fff9c4', borderRadius: 2, border: '1px solid #fff59d' }}>
                  <Typography variant="body2" color="brown">
                    <strong>Note:</strong> Our team usually responds within 24-48 business hours.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>

    </Box>
  );
};

export default ContactUsPage;